import { render, staticRenderFns } from "./PopupHomePage.vue?vue&type=template&id=44aae515&scoped=true&"
import script from "./PopupHomePage.vue?vue&type=script&lang=js&"
export * from "./PopupHomePage.vue?vue&type=script&lang=js&"
import style0 from "./PopupHomePage.vue?vue&type=style&index=0&id=44aae515&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44aae515",
  null
  
)

export default component.exports